import { useEffect, useState } from "react"
import "./Policy.css"
import { useNavigate } from "react-router-dom"
import { ConeStriped, Info } from "react-bootstrap-icons"
import { Button, Modal, Table } from "react-bootstrap"
import { format } from "date-fns"

interface ISchedule {
    date: string,
    open_time: string,
    box_office_hours: string,
    black_bar_hours: string
}

export const NewYearSchedule = () => {
    const [show, setShow] = useState<any>()
    const [schedule, setSchedule] = useState<ISchedule[] | null>(null);
    const [showSchedule, setShowSchedule] = useState<boolean>(false)
    const [scheduleToDay, setScheduleToDay] = useState<ISchedule | null>(null)
    const [tomorrow, setTomorrow] = useState<ISchedule | null>(null)
    const agreePolicy = () => {
        sessionStorage.setItem("agreeSchedule", "true")
    }
    const navigete = useNavigate()
    const toNav = (link: string) => {
        window.scrollTo(0, 0)
        navigete(link)
    }

    const getTomorrowDate = () => {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1); // добавляем 1 день
        return tomorrow.toISOString().split('T')[0]; // возвращаем как "2025-12-14"
    }

    useEffect(() => {

        // Определяем границы времени
        const start = new Date("2025-12-22T00:00:00"); // 20.12.25 16:00
        const end = new Date("2026-01-09T23:00:00");   // 22.12.25 00:00
        const now = new Date();

        // Проверяем, входит ли текущее время в диапазон
        const isTimeInRange = now >= start && now < end;

        if (!isTimeInRange) {
            return;
        }
        fetch("/schedule-ny.json")
            .then(res => {
                if (!res.ok) throw new Error("Ошибка загрузки файла");
                return res.json(); // Преобразуем ответ в JSON
            })
            .then(data => {
                const dSchedule = data.schedule as ISchedule[]
                if (dSchedule && dSchedule.length > 1) {
                    setSchedule(dSchedule.filter(item => {
                        const itemDate = new Date(item.date); // например, "2025-12-15" → 00:00:00 UTC
                        const today = new Date(); // текущая дата и время
                        today.setHours(0, 0, 0, 0); // обнуляем время → начало сегодняшнего дня (локальное)
                        return itemDate >= today; // включаем сегодня и будущее
                    })); // Сохраняем данные в состоянии
                    const sToData = dSchedule.find((item: ISchedule) => {
                        const itemDate = new Date(item.date);
                        const today = new Date();
                        // Функция для получения "ключ-даты" в локальном формате
                        const getLocalDateKey = (date: Date) => {
                            return date.toLocaleDateString('sv-SE'); // 'sv-SE' → YYYY-MM-DD
                        };

                        return getLocalDateKey(itemDate) === getLocalDateKey(today);
                    });
                    const tomorrow = getTomorrowDate(); // например: "2025-12-14"

                    const sNToData = dSchedule.find((item: ISchedule) => {
                        const itemDate = new Date(item.date);
                        const itemDateStr = itemDate.toISOString().split('T')[0];
                        return itemDateStr === tomorrow;
                    });
                    setScheduleToDay(sToData ?? null);
                    setTomorrow(sNToData ?? null)
                    setScheduleToDay(sToData ?? null)
                    return;
                }
                return setSchedule(null)

            })
            .catch(err => {
                console.error("Ошибка:", err);
            });
        const status = sessionStorage.getItem("agreeSchedule")
        if (status !== "true") {
            setTimeout(() => {
                setShow('is-widget-open')
            }, 1000)
        }
    }, [])

    const close = () => {
        setShow(null)
        agreePolicy()
    }

    if (!schedule) {
        return <></>
    }

    return (
        <>
            <div className={`${show} policy-widget policy-widget-new-year`}>
                <div className="policy-wrapper policy-wrapper-new-year" style={{ backgroundImage: 'url("/newyear.png")' }}>
                    <div className="policy-widget-container">
                        <div className="widget__item">
                            {/* <div className="policy-image">
                                <ConeStriped size={90} />
                            </div> */}
                            <div className="policy-text policy-text-icon text-justify">
                                <div className="mb-2 fs-6">
                                    Уважаемые гости!
                                </div>
                                <div className="fs-6">Обращаем ваше внимание на изменение графика работы Ленинград Центра в праздничные и предпраздничные дни.</div>
                                <div><a className="mt-2 fs-6 fw-bold text-black" style={{ cursor: "pointer" }} onClick={() => { setShowSchedule(!showSchedule) }}>Ознакомиться с графиком</a></div>
                                <div className="d-lg-flex d-grid gap-2">
                                    {scheduleToDay &&
                                        <div className="fs-6 fw-bold">
                                            {/* <div className="fw-bold">Режим работы сегодня {format(new Date(scheduleToDay.date), "dd.MM.yyyy")}</div> */}
                                            <div className="fw-bold">Режим работы сегодня</div>
                                            <div className="fw-bold">Открытие Ленинград Центра с {scheduleToDay.open_time}</div>
                                            <div>Касса: {scheduleToDay.box_office_hours}</div>
                                            <div>Черный бар: {scheduleToDay.black_bar_hours}</div>
                                        </div>
                                    }
                                    {/* {tomorrow &&
                                        <div className="fs-6 fw-bold">
                                            <div className="fw-bold">Работы завтра</div>
                                            <div className="fw-bold">Открытие Ленинград Центра с {tomorrow.open_time}</div>
                                            <div>Касса: {tomorrow.box_office_hours}</div>
                                            <div>Черный бар: {tomorrow.black_bar_hours}</div>
                                        </div>
                                    } */}
                                </div>

                                <div className="mt-2 me-auto text-end">
                                    <button className="btn btn-lc btn-lc-rounded" onClick={() => { close() }}>Понятно, спасибо</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={showSchedule} size="lg" style={{ zIndex: 4000 }} onHide={() => { setShowSchedule(false) }}>
                <Modal.Header closeButton className="fs-5">
                    График работы в праздничные и предпраздничные дни
                </Modal.Header>
                <Modal.Body>
                    <Table style={{ fontSize: '12px', background: '#f3efea' }}>
                        <thead style={{ background: 'linear-gradient(90deg,rgba(179, 122, 81, 1) 0%, rgba(242, 219, 162, 1) 100%)' }}>
                            <tr className="align-items-center justify-content-center text-center" style={{ verticalAlign: 'middle' }}>
                                <td style={{ background: 'transparent' }}>Дата</td>
                                <td style={{ background: 'transparent' }}>Открытие дверей
                                    <br />"Ленинград Центра"</td>
                                <td style={{ background: 'transparent' }} className="align-items-center justify-content-center">Режим работы кассы</td>
                                <td style={{ background: 'transparent' }}>Режим работы Черного бара</td>
                            </tr>
                        </thead>
                        <tbody>
                            {schedule &&
                                schedule
                                    .filter(item => {
                                        const itemDate = new Date(item.date); // например, "2025-12-15" → 00:00:00 UTC
                                        const today = new Date(); // текущая дата и время
                                        today.setHours(0, 0, 0, 0); // обнуляем время → начало сегодняшнего дня (локальное)
                                        return itemDate >= today; // включаем сегодня и будущее
                                    })
                                    .map((item) => (
                                        <tr style={{ background: 'transparent' }} key={item.date} className="fw-bold text-center">
                                            <td style={{ background: 'transparent' }}>{format(new Date(item.date), "dd.MM.yyyy")}</td>
                                            <td style={{ background: 'transparent' }}>{item.open_time}</td>
                                            <td style={{ background: 'transparent' }}>{item.box_office_hours}</td>
                                            <td style={{ background: 'transparent' }}>{item.black_bar_hours}</td>
                                        </tr>
                                    ))
                            }

                        </tbody>
                    </Table>
                </Modal.Body>
            </Modal>
            {/* } */}
        </>
    )
}